module.exports = __webpack_public_path__ + "img/39_75.a02d4bff.png";